import {readable} from 'svelte/store';

export const constants = readable({
    social: {
        vk: {url: 'https://vk.com/qparser'},
        ok: {url: 'https://ok.ru/qparser'},
        youtube: {url: 'https://youtube.com/channel/qparser'},
    } as Record<string, {url: string}>,

    tariff: {
        supplier: {
            // Тарифы для поставщиков
            free: [0, 950, 0, 2250, 0, 0, 3950], // Бесплатный доступ по месяцам (индекс - период)
        },
    },

    website_request: {
        price: 950, // Стоимость настройки нового сайта
        old_price: 950, // Старая стоимость настройки нового сайта

        price_private: 2000, // Стоимость приватного сайта
        old_price_private: 3000, // Старая стоимость приватного сайта
    },

    ai_points: {
        precision: 1000, // Точность отображения AIP
        price: 150, // Стоимость одного AIP (реального, без precision)
    },

    referral: {
        percent: 10, // Процент начислений по реферальной программе
    },
});
